import Vue from "vue";
import VueRouter from "vue-router";
import empty from "@404";
import squirrelCup from './squirrelCup'
import {applyRouterGuard} from "@router/routerGuard";
Vue.use(VueRouter);

const routes = [
  { path: "/", name: "empty", component: empty },
  {
    path: "/winterGame/alliance",
    name: "main",
    meta: { title: "我的战队" },
    component: () => import("@views/WinterGame/alliance.vue"),
  },
  {
    path: "/winterGame/main",
    name: "main",
    meta: { title: "报名" },
    component: () => import("@views/WinterGame/main.vue"),
  },
  {
    path: "/winterGame/details",
    name: "details",
    meta: { title: "详情" },
    component: () => import("@views/WinterGame/details.vue"),
  },
  {
    path: "/winterGame/createTeam",
    name: "createTeam",
    meta: { title: "创建战队" },
    component: () => import("@views/WinterGame/createTeam.vue"),
  },
  {
    path: "/winterGame/createSuccess",
    name: "createSuccess",
    meta: { title: "创建战队" },
    component: () => import("@views/WinterGame/createSuccess.vue"),
  },
  {
    path: "/winterGame/addTeamMembers",
    name: "addTeamMembers",
    meta: { title: "添加队员" },
    component: () => import("@views/WinterGame/addTeamMembers.vue"),
  },
  {
    path: "/winterGame/register",
    name: "register",
    meta: { title: "松鼠杯" },
    component: () => import("@views/WinterGame/register.vue"),
  },
  {
    path: "/winterGame/offDay",
    name: "offDay",
    meta: { title: "休赛日" },
    component: () => import("@views/WinterGame/offDay.vue"),
  },
  {
    path: "/winterGame/memberRecord",
    name: "memberRecord",
    meta: { title: "成员成绩" },
    component: () => import("@views/WinterGame/memberRecord.vue"),
  },
  {
    path: "/winterGame/memberDetail/:accountId/:subject/:cupName/:seasonId/:scheduleId",
    name: "memberDetail",
    meta: { title: "个人战绩" },
    component: () => import("@views/WinterGame/memberDetail.vue"),
  },
  {
    path: "/winterGame/myTeam2",
    name: "myTeam",
    meta: { title: "我的战队" },
    component: () => import("@views/WinterGame/myTeam.vue"),
  },
  {
    path: "/WinterGame/groupCompetition",
    name: "groupCompetition",
    meta: { title: "小组赛" },
    component: () => import("@views/WinterGame/groupCompetition.vue"),
  },
  {
    path: "/WinterGame/theGame",
    name: "theGame",
    meta: { title: "松鼠杯冬季赛" },
    component: () => import("@views/WinterGame/theGame.vue"),
  },
  {
    path: "/WinterGame/thereAreTeams",
    name: "thereAreTeams",
    meta: { title: "有战队代理商" },
    component: () => import("@views/WinterGame/thereAreTeams.vue"),
  },
  {
    path: "/winterGame/historyResult",
    name: "historyResult",
    meta: { title: "历史战绩" },
    component: () => import("@views/WinterGame/historyResult.vue"),
  },

  {
    path: "/winterGame/moreHonor",
    name: "moreHonor",
    meta: { title: "我的战队" },
    component: () => import("@views/WinterGame/moreHonor.vue"),
  },
  {
    path: "/winterGame/moreRecord",
    name: "moreRecord",
    meta: { title: "战队战绩" },
    component: () => import("@views/WinterGame/moreRecord.vue"),
  },
  {
    path: "/winterGame/studentAchievement",
    name: "studentAchievement",
    meta: { title: "出战成员战绩" },
    component: () => import("@views/WinterGame/studentAchievement.vue"),
  },
  {
    path: "/winterGame/bonusDetail",
    name: "bonusDetail",
    meta: { title: "获得点券明细" },
    component: () => import("@views/WinterGame/bonusDetail.vue"),
  },
  {
    path: "/winterGame/bonusPayment",
    name: "bonusPayment",
    meta: { title: "奖励发放" },
    component: () => import("@views/WinterGame/bonusPayment.vue"),
  },
  {
    path: "/winterGame/bonusRules",
    name: "bonusRules",
    meta: { title: "我的战队" },
    component: () => import("@views/WinterGame/bonusRules.vue"),
  },
  {
    path: "/winterGame/moreSchedule",
    name: "moreSchedule",
    meta: { title: "战队赛程" },
    component: () => import("@views/WinterGame/moreSchedule.vue"),
  },
  {
    path: "/winterGame/teamRecord",
    name: "teamRecord",
    meta: { title: "比赛数据" },
    component: () => import("@views/WinterGame/teamRecord.vue"),
  },
  {
    path: '/winterGame/rests',
    name: "rests",
    meta: {
        title: "比赛数据"
    },
    component: () => import("@views/WinterGame/rests.vue"),
},
  {
    path: "/winterGame/notRecord",
    name: "notRecord",
    meta: { title: "通知中心" },
    component: () => import("@views/WinterGame/notRecord.vue"),
  },
  {
    path: "/winterGame/notDetail",
    name: "notDetail",
    meta: { title: "通知详情" },
    component: () => import("@views/WinterGame/notDetail.vue"),
  },
  {
    path: "/winterGame/honorRoll",
    name: "honorRoll",
    meta: { title: "松鼠杯" },
    component: () => import("@views/WinterGame/honorRoll.vue"),
  },
  {
    path: "/winterGame/home",
    name: "home",
    meta: { title: "松鼠杯" },
    component: () => import("@views/WinterGame/home.vue"),
  },
  {
    path: "/winterGame/rewardDistributionDetails",
    name: "rewardDistributionDetails",
    meta: { title: "松鼠杯" },
    component: () => import("@views/WinterGame/rewardDistributionDetails.vue"),
  },
  {
    path: "/winterGame/draw-lots",
    name: "drawLots",
    meta: { title: "松鼠杯" },
    component: () => import("@views/WinterGame/drawLots.vue"),
  },
    ...squirrelCup
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

// 应用全局导航守卫
applyRouterGuard(router);

// 路由跳转后返回页面顶端

export default router;
